import React from 'react';
import StepShell from './StepShell';
import { Badge } from '../../../ui/badge';
import { Alert, AlertDescription, AlertTitle } from '../../../ui/alert';
import { Edit3, Home, Building2, Car, Leaf, ShieldCheck } from 'lucide-react';
import { Link } from 'react-router-dom';

const Row = ({ label, value }) => (
  <div className='flex items-start justify-between gap-3 py-1.5'>
    <span className='text-xs text-muted-foreground'>{label}</span>
    <span className='text-sm text-right font-medium'>{value}</span>
  </div>
);

const Section = ({ title, icon: Icon, editSlug, children }) => (
  <div className='rounded-xl border border-border p-3.5'>
    <div className='flex items-center justify-between mb-2'>
      <div className='flex items-center gap-2'>
        <div className='w-7 h-7 rounded-md bg-primary/10 flex items-center justify-center text-accent'>
          <Icon size={14} strokeWidth={1.5} />
        </div>
        <div className='font-display text-sm'>{title}</div>
      </div>
      <Link
        to={`/prototype/wfh-survey/employee/step/${editSlug}`}
        className='text-xs text-accent flex items-center gap-1 hover:underline'>
        <Edit3 size={11} strokeWidth={1.5} />
        Edit
      </Link>
    </div>
    <div>{children}</div>
  </div>
);

const ReviewSubmit = () => (
  <StepShell
    title='Quick check'
    description='Review your answers. Tap Edit to change anything before submitting.'>
    <Section title='About you' icon={Building2} editSlug='employment'>
      <Row label='Office' value='Bristol' />
      <Row label='Worked full period?' value='Yes' />
    </Section>

    <Section title='Working pattern' icon={Home} editSlug='working-pattern'>
      <Row label='Days per week' value='5' />
      <Row label='WFH days' value='3' />
      <Row label='Commute days' value='2' />
    </Section>

    <Section title='Home office' icon={Home} editSlug='wfh-equipment'>
      <Row label='Laptops / desktops / monitors' value='1 / 0 / 1' />
      <Row label='Video calls' value='6-10 hrs/week' />
      <Row label='Heating' value='Gas · 6 hr/day · 5 months · whole home' />
      <Row label='Electricity' value='Standard tariff · no solar' />
    </Section>

    <Section title='Commute' icon={Car} editSlug='commuting'>
      <Row label='Days per week' value='2' />
      <Row label='Leg 1' value='Walk · 0.6 km' />
      <Row label='Leg 2' value='Train · 18.4 km' />
      <Row label='Leg 3' value='Walk · 0.4 km' />
    </Section>

    <div className='flex items-center gap-2 flex-wrap'>
      <Badge variant='success' size='default'>
        <Leaf size={10} strokeWidth={1.5} />
        Estimated ~0.38 tCO2e / year
      </Badge>
      <Badge variant='outline' size='default'>
        Below company average
      </Badge>
    </div>

    <Alert>
      <ShieldCheck size={14} strokeWidth={1.5} />
      <AlertTitle>Ready to submit</AlertTitle>
      <AlertDescription>
        Once you tap Submit we'll add your answers to the aggregate totals. You can still amend within 24 hours via your
        original email link.
      </AlertDescription>
    </Alert>
  </StepShell>
);

export default ReviewSubmit;
